import { Link } from "react-router-dom";
import { Check, CreditCard } from "lucide-react";
import { PublicLayout } from "@/components/PublicLayout";
import { INCLUDED_FEATURES } from "@/data/pricing";
import { PricingFaq } from "@/components/PricingFaq";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Pricing() {
  usePageMeta({ title: "Pricing — $19.99 lifetime access | Mindful Me", description: "One payment of $19.99 for lifetime access to every Mindful Me feature. No subscription, pay by card or PayPal, full refund within 14 days.", path: "/pricing" });
  return (
    <PublicLayout>
      <section className="max-w-xl mx-auto px-5 pt-16 text-center mm-fade-up">
        <h1 className="text-4xl sm:text-5xl font-extrabold">Simple, honest pricing</h1>
        <p className="text-mm-muted mt-3">One payment. Lifetime access. No subscriptions.</p>
        <div className="mm-card p-8 mt-10 text-left" data-testid="pricing-card">
          <div className="text-sm font-semibold text-mm-primary uppercase tracking-wider">Lifetime Unlock</div>
          <div className="flex items-baseline gap-2 mt-2">
            <span className="font-display text-5xl font-extrabold" data-testid="pricing-amount">$19.99</span>
            <span className="text-mm-muted">one-time</span>
          </div>
          <ul className="mt-6 space-y-3">
            {INCLUDED_FEATURES.map((f) => (
              <li key={f} className="flex gap-3 items-start"><Check size={18} className="text-mm-success mt-0.5 shrink-0" />{f}</li>
            ))}
          </ul>
          <div className="mt-6 flex items-center gap-3 text-sm text-mm-muted" data-testid="pricing-payment-methods">
            <span>Pay securely with PayPal</span>
            <span className="inline-flex items-center gap-1 border rounded-md px-2 py-1 text-mm-text" data-testid="pricing-card-logo"><CreditCard size={16} />Card</span>
            <span className="inline-flex items-center border rounded-md px-2 py-1 font-extrabold italic" data-testid="pricing-paypal-logo">
              <span style={{ color: "#003087" }}>Pay</span><span style={{ color: "#009CDE" }}>Pal</span>
            </span>
          </div>
          <Link to="/checkout" className="mm-btn w-full mt-4" data-testid="pricing-get-started">Get Started</Link>
        </div>
      </section>
      <PricingFaq />
    </PublicLayout>
  );
}
